<template>
<div>
    <div class="row justify-content-around" style="margin-top: 50px">
        <div class="col-lg-5"> 
            <img :src="item.image_path !== null ? '/storage/'+item.image_path+'?filever='+ver : '/images/WillCall_NoImage_500.jpg'" class="img-fluid" alt="product image">
        </div>
        <div class="col-lg-5">
            <h3>{{ item.name }}</h3>
            <p v-if="item.brand"><a :href="'/brand/' + slug">{{ item.brand }}</a></p><br>
            <h3 v-if=" item.is_special == 0 ">{{ '$' + item.price.toFixed(2) }}</h3>
            <h3 v-else><strike>{{ '$' + item.price.toFixed(2) }}</strike><br>{{ '$' + item.special_price.toFixed(2) }} *SPECIAL*</h3><br>
            <p>
                <strong>Details: </strong>{{item.details}}
            </p>
            <p>
                <strong>Item #: </strong>{{item.id}}
            </p>
            <p class="text-danger" v-if="item.stock == 'low'"> 
                <b>Limited Quantity Available </b>
            </p>
            <a v-if="item.stock == 'out' && item.category != 'Featured'" href="#" class="btn btn-secondary disabled" tabindex="-1" role="button" aria-disabled="true">OUT OF STOCK</a>
            <div v-else>
                <p>
                    <div class="qty-input">
                        <i class="fas fa-minus"></i>
                        <input type="text" value="1" id="quantity" />
                        <i class="fas fa-plus"></i>
                    </div>
                </p>
                <br>          
                <button class="btn btn-success" @click="addToCart">
                    <i class="fa fa-shopping-cart"></i> ADD TO CART
                </button>
            </div>
        </div>
    </div>
    <div class="row justify-content-center mt-5">
        <div class="col-md-10">
            <div class="card w-100">
                <h5 class="card-header">Description</h5>
                <div class="card-body">
                    <p class="card-text" style="white-space: pre-wrap">{{item.description}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        props: ['item'],
        data: function () {
            return {
                ver: moment(this.item.updated_at).format('X')
            }
        },
        methods: {
            addToCart() {           
                const formData = new FormData();
                formData.append("id", this.item.id);
                formData.append("quantity",$("#quantity").val());
                
                axios.post("/cart/add", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(response => {  
                    Event.fire('updateCart',{});     
                    $("#itemadded").addClass('show');
                    window.setTimeout(function () {                        
                        $("#itemadded").removeClass('show');
                    }, 2000);
                });
            },            
            slugify (text, ampersand = 'and') {
                const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧ'
                const b = 'aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzh'
                const p = new RegExp(a.split('').join('|'), 'g')

                return text.toString().toLowerCase()
                    .replace(/[\s_]+/g, '-')
                    .replace(p, c =>
                    b.charAt(a.indexOf(c)))
                    .replace(/&/g, `-${ampersand}-`)
                    .replace(/[^\w-]+/g, '')
                    .replace(/--+/g, '-')
                    .replace(/^-+|-+$/g, '')
            }
        },
        computed: {
            slug: function () {
                return this.slugify(this.item.brand)
            }
        }
    }
    
</script>
